import {isObject} from '../types/isObject';

export function objAnyValue<TValue>(obj: { readonly [index: number]: TValue },
                                    predicate: (value: TValue) => boolean): boolean
export function objAnyValue<TValue>(obj: { readonly [index: string]: TValue },
                                    predicate: (value: TValue) => boolean): boolean
export function objAnyValue<TValue>(obj: { readonly [index: string]: TValue },
                                    predicate: (value: TValue) => boolean): boolean {
  if (!isObject(obj))
    return false;
  for (let key in obj)
    if (predicate(obj[key]))
      return true;
  return false;
}
